export default {
  isLoading: false,
  isSubmitting: false,
  isLoggedIn: false,
  currentUser: null,
  errors: null,
  validationErrors: null,
};
